import { LabelColors } from '@aibees/elephant/types/label';
import { FormProps } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';

export const formConfig: FormProps = {
  scheme: yup.object().shape({
    description: yup.string(),
  }),
};

export const labelColors: LabelColors[] = [
  {
    name: 'Blue',
    hexCode: '#0D3CBF',
    value: 'blue',
    selected: false,
  },
  {
    name: 'Violet',
    hexCode: '#632778',
    value: 'violet',
    selected: false,
  },
  {
    name: 'Brown',
    hexCode: '#8A4D04',
    value: 'brown',
    selected: false,
  },
  {
    name: 'Orange',
    hexCode: '#E78709',
    value: 'orange',
    selected: false,
  },
  {
    name: 'Red',
    hexCode: '#BC0F0F',
    value: 'red',
    selected: false,
  },
  {
    name: 'Yellow',
    hexCode: '#D3A500',
    value: 'yellow',
    selected: false,
  },
  {
    name: 'Green',
    hexCode: '#05603A',
    value: 'green',
    selected: false,
  },
  {
    name: 'Gray',
    hexCode: '#999999',
    value: 'gray',
    selected: false,
  },
];
